// client/nodes/text.ts
import { TEXT_KEY, TEXT_SCHEMA } from "../../schema/nodes/text.js";
var text = () => ({
  node: {
    name: TEXT_KEY,
    schema: TEXT_SCHEMA()
  }
});
export {
  text
};
